import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';
import { Form } from '@/components';
import { Button, Select } from '@/ui';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
`;

export const StyledForm = styled(Form)`
  justify-content: space-between;
  height: 100%;
`;

export const StyledTitle = styled.div`
  ${pickThemeFontStyles('18', '24', 'BOLD')};
  display: flex;
  color: ${COLORS.DARK_ONYX} !important;
  align-items: center;
  gap: 1rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    ${pickThemeFontStyles('24', '30', 'BOLD')};
  }
`;

export const FormColumn = styled.div`
  flex-direction: column;
  gap: 1rem;
  display: flex;
`;

export const StyledButton = styled(Button)`
  &&& {
    width: 100%;
    min-height: 3rem;
    margin: 1rem 0;
    ${pickThemeFontStyles('14', '18', 'BOLD')};
  }
`;

export const StyledSelect = styled(Select)`
  &&& {
    height: auto;

    .ant-select-selection-placeholder {
      color: ${COLORS.BLACK};
    }

    .ant-select-selector {
      overflow: hidden;
      padding-top: 0.15rem;
    }

    .ant-select-selection-overflow {
      white-space: nowrap;

      & .ant-select-selection-overflow-item span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 8vw;
      }

      & .ant-select-selection-overflow-item-rest div {
        border: none;
        color: ${COLORS.GRAY_PRIMARY};
      }

      & .ant-select-selection-overflow-item-suffix {
        padding-left: 0.25rem;
      }
    }

    .ant-select-clear {
      inset-inline-end: 0.25rem;
      top: 50%;
      width: fit-content;
      height: fit-content;
    }
  }
`;

export const StyledButtonsWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledLink = styled.a`
  &&& {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    height: auto;
    background: ${COLORS.WHITE};
    padding: 0.25rem;
    border: 1px solid ${COLORS.BLACK_PRIMARY};
    border-radius: 0.2rem;
    height: 2.125rem;

    :hover {
      background: ${COLORS.PALE_YELLOW};
      color: ${COLORS.BLACK};
      border: none;
      svg {
        path {
          fill: ${COLORS.WHITE};
        }
      }
    }
  }

  svg {
    transform: scale(1.5);
    path {
      fill: ${COLORS.BLACK};
    }
  }
`;

export const StyledActionButton = styled(Button)`
  &&& {
    background: ${COLORS.WHITE};
    padding: 0.25rem;
    border: none;
    height: 2.125rem;
    border: 1px solid ${COLORS.BLACK_PRIMARY};

    :hover {
      background: ${COLORS.PALE_YELLOW};
      border: none;
      svg {
        path {
          fill: ${COLORS.WHITE};
        }
      }
    }
  }

  svg {
    path {
      fill: ${COLORS.BLACK};
    }
  }
`;
